import { createEligibility } from '@lib/web3/contracts/Eligibility';
import createContractHook from '@lib/web3/hooks/contracts/createContractHook';

const useEligibility = createContractHook(createEligibility);
export default useEligibility;
